import { Collection } from 'modules/core/lib/mobx-rest'

import PayrollResult from 'modules/bookkeepers/store/models/PayrollResult'

interface ChangePeriodWithDocumentsOptions {
  payslip_documents: File[]
  payroll_summary_documents: File[]
  policy_period_id: number
  bookkeeper_view: boolean
}

class PayrollResults extends Collection<PayrollResult> {
  get cacheKey(): string {
    return 'payrollResults'
  }

  model() {
    return PayrollResult
  }

  changePeriodWithDocuments(data: ChangePeriodWithDocumentsOptions) {
    return this.rpc('change_period_with_documents', data)
  }
}

const singleton: PayrollResults = new PayrollResults()

export default singleton
